import { CLOSE_AUCTION_CONTRACT_MODAL, CREATE_BET, OPEN_DEMO_MODAL } from 'dealer-reducers'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import Button from 'src/components/atoms/Button'
import PriceInput from 'src/components/atoms/PriceInput'
import Space from 'src/components/atoms/Space'
import Text from 'src/components/atoms/TextNew'
import View from 'src/components/atoms/View'
import { minBetRise } from '../../../consts/other'
import track from 'src/helpers/track'
import useDealerAllowedToPlaceOffer from 'src/hooks/useDealerAllowedToPlaceOffer'
interface Props {
  offerId: number
  highestBet: number
}
const AuctionContractModalContent = ({ offerId, highestBet }: Props): JSX.Element => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const dealerAllowedToPlaceOffer = useDealerAllowedToPlaceOffer()
  const [value, setValue] = useState(0)

  return (
    <View className="flex flex-col items-center px-5 h-full">
      <Space y={30} />
      <Text className="text-xl text-white text-center font-SemiBold">
        <>{t('auction_contract_modal.title')}</>
      </Text>
      <Space y={3} />
      <View className="flex justify-center items-center max-w-[220px]">
        <PriceInput value={value} minimalPrice={highestBet + minBetRise} onSetValue={setValue} />
      </View>
      <View className="flex-1" />
      <View
        dangerouslySetInnerHTML={{ __html: t('auction_contract_modal.term') }}
        className=" text-white text-l text-center"></View>
      <Space y={2} />
      <View className="flex flex-col justify-center items-center gap-2">
        <View className="flex gap-2 justify-between max-w-[400px]">
          <Button color="transparent" variant="medium" onClick={() => dispatch(CLOSE_AUCTION_CONTRACT_MODAL())}>
            <Text className="text-xl text-white font-SemiBold">
              <>{t('auction_contract_modal.resign')}</>
            </Text>
          </Button>
          <Button
            variant="medium"
            customStyles="!rounded-[10px] !min-w-[160px]"
            disabled={!dealerAllowedToPlaceOffer}
            onClick={() => {
              if (!dealerAllowedToPlaceOffer) {
                dispatch(OPEN_DEMO_MODAL())
                return
              }
              track('dealer_create_bet')
              track('dealer_create_bet_on_offer')
              track('dealer_meaningful_action')
              dispatch(CREATE_BET({ offerId, betValue: value }))
            }}>
            <Text className="text-xl  text-white font-SemiBold">
              <>{t('auction_contract_modal.place_offer')}</>
            </Text>
          </Button>
        </View>
      </View>
      <Space y={10} />
    </View>
  )
}

export default AuctionContractModalContent
